var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuote2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16.252,
    height: 16.252,
    viewBox: "0 0 16.252 16.252",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1105",
    "data-name": "Rectangle 1105",
    width: 16.252,
    height: 16.252,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3326",
    "data-name": "Group 3326",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3325",
    "data-name": "Group 3325",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2143",
    "data-name": "Path 2143",
    d: "M13.964,16.252H2.289A2.291,2.291,0,0,1,0,13.964V2.288A2.291,2.291,0,0,1,2.289,0H13.964a2.291,2.291,0,0,1,2.289,2.288V13.964a2.291,2.291,0,0,1-2.289,2.288m-7.72-1.239h7.72a1.051,1.051,0,0,0,1.049-1.049V6.244H6.244Zm-5-8.769v7.72a1.051,1.051,0,0,0,1.049,1.049H5V6.244Zm5-1.24h8.769V2.288A1.05,1.05,0,0,0,13.964,1.24H6.244Zm-5,0H5V1.24H2.289A1.05,1.05,0,0,0,1.24,2.288Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote2);
export default __webpack_public_path__ + "static/media/quote2.ec93ec55ba571edfe848511866bf8492.svg";
export { ForwardRef as ReactComponent };